module.exports = __webpack_public_path__ + "img/inventoryManagement.55e39c4e.svg";